import React from 'react';
import './DescriptionPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="page-container description-page">
      <h1>Политика конфиденциальности</h1>
      <p>Эта политика конфиденциальности описывает, какие персональные данные мы собираем и как используем их в рамках исследования эмоций.</p>
      <p>Мы собираем только данные, предоставленные вами добровольно, включая ФИО, возраст, пол и адрес электронной почты.</p>
      <p>Данные используются исключительно для целей исследования и не передаются третьим лицам, за исключением случаев, предусмотренных законодательством.</p>
      <p>Вы можете запросить удаление своих данных, связавшись с организаторами исследования.</p>
    </div>
  );
}

export default PrivacyPolicyPage;